/**
 *
 * 1) Add this to a component mixins array
 * 2) Listen to the val variable
 *
 */

export default {
    props: {
        value: {},

        readonly: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        val: {
            get() {
                return this.value;
            },

            set(val) {
                if (!this.readonly) this.$emit("input", val);
            }
        }
    }
};
